import { render, staticRenderFns } from "./Chatbox.vue?vue&type=template&id=40e49e9f&scoped=true&"
import script from "./Chatbox.vue?vue&type=script&lang=js&"
export * from "./Chatbox.vue?vue&type=script&lang=js&"
import style0 from "./Chatbox.vue?vue&type=style&index=0&id=40e49e9f&lang=scss&scoped=true&"
import style1 from "./Chatbox.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e49e9f",
  null
  
)

export default component.exports